var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolderLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19652)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.7C9 13.0925 11.0925 11 13.7 11H17.8C18.8314 11 19.9875 11.3743 20.8042 12.055L20.8075 12.0577L25.5007 16H34.5C37.1075 16 39.2 18.0925 39.2 20.7V32.5C39.2 35.1075 37.1075 37.2 34.5 37.2H13.7C11.0925 37.2 9 35.1075 9 32.5V15.7ZM13.7 13.2C12.3075 13.2 11.2 14.3075 11.2 15.7V32.5C11.2 33.8925 12.3075 35 13.7 35H34.5C35.8925 35 37 33.8925 37 32.5V20.7C37 19.3075 35.8925 18.2 34.5 18.2H25.1C24.8412 18.2 24.5907 18.1087 24.3925 17.9423L19.3958 13.745C19.3953 13.7446 19.3948 13.7443 19.3944 13.7439C19.011 13.4251 18.3679 13.2 17.8 13.2H13.7Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.2,
    height: 26.2,
    fill: "white",
    transform: "translate(9 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderLight);
export default __webpack_public_path__ + "static/media/icon_folder_light.2dcd844a.svg";
export { ForwardRef as ReactComponent };